import axios from "axios";
import { env } from "../env";
import { store } from "redux/store";
import { setIsLogin } from "redux/signPassIdentify";
import { changeIsLoading } from "redux/loading";
import { identity } from "lodash";
import {APPT_TYPE, CREATE_BOOKING_STATUS, DATE_FORMAT, DATE_ID_FORMAT, ID_TYPE, TIME_SLOT_FORMAT, UPDATE_BOOKING_STATUS} from "../constants/o2Appointment";
import moment from "moment";
import { updateBookingTxnId, updateError, updateState } from "redux/o2Appointment";

const ERROR = "error";

// api-service.js already have global interceptors
/* axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    store.dispatch(changeIsLoading(true));
    config.withCredentials = true;
    return config;
  },
  function (error) {
    // Do something with request error
    store.dispatch(changeIsLoading(false));
    return Promise.reject(error);
  }
); */

/* axios.interceptors.response.use(
  function (response) {
    store.dispatch(changeIsLoading(false));
    if (response?.data?.status === ERROR) {
      debugger;
      store.dispatch(updateError("Unexpected error has occurred. Please try again later."));
      response.status = 500;
    }
    return response;
  },
  function (error) {
    store.dispatch(changeIsLoading(false));
    debugger;
    store.dispatch(updateError("Unexpected error has occurred. Please try again later."));

    if (error?.response?.status === 401) {
      store.dispatch(setIsLogin(false));
      return error.response;
    }
    

    return Promise.reject(error);
  }
); */

export async function sendSms({ nric, mobileNumber }) {
  return await axios.post(`${env.apiUrl}/public/queue`, { nric, mobileNumber });
}


export async function getOtp(nric, mobileNumber) {
  return await axios.post(`${env.apiUrl}/public/otp/get`, {
    nric,
    mobile: mobileNumber
  });
}

export async function validateOtpToken(otpToken) {
  let result = null;
  try {
    result = await axios.get(
      `${env.apiUrl}/api/oas/otp/validateToken?otpToken=${encodeURIComponent(otpToken)}`
    );
    if (result.status === 401) {
      return { status: "NO_AUTH" };
    }
    return result.data.data;
  } catch (e) {
    return { status: "ERROR" };
  }
}

export async function getService() {
  return await axios.get(`${env.apiUrl}/api/oas/main-service`);
}

export async function getSubService(mainServiceId) {
  return await axios.get(`${env.apiUrl}/api/oas/main-service/${mainServiceId}`);
}

export async function getServiceChannels(age, subServiceId, isCrps) {
  return await axios.get(
    `${env.apiUrl}/api/oas/service-channels?age=${age}&subServiceId=${subServiceId}&isCrps=${isCrps}`
  );
}

export async function getAppointmentBooking(appointmentTypeId) {
  return await axios.get(
    `${env.apiUrl}/api/oas/appointment-booking?appTypeId=${appointmentTypeId}`
  );
}

/* export async function getTimeSlots(date, locationId, appointmentTypeId) {
  return await axios.get(
    `${env.apiUrl}/api/oas/timeslots?date=${date}&locationId=${locationId}&appTypeId=${appointmentTypeId}`
  );
} */

export async function getSuggestedTimeSlots(appointmentTypeId) {
  return await axios.get(
    `${env.apiUrl}/api/oas/appointment-booking-suggested-slot-day?appTypeId=${appointmentTypeId}`
  );
}

export async function getTimeSlotsWithoutLocationId(date, appointmentTypeId) {
  return await axios.get(
    `${env.apiUrl}/api/oas/timeslots-without-location?date=${date}&appTypeId=${appointmentTypeId}`
  );
}

export async function changeAppointmentBooking(
  serviceId,
  subServiceId,
  enquiryForId,
  visitorIdentity,
  birthYear,
  preferLang,
  otherEnquiryServiceId,
  contactNo,
  apptTypeId,
  attendingWithAnotherPerson,
  locationId,
  appointmentDt,
  liveApptTimeslotId,
  previousBookingId,
  previousLiveAppTimeslotId,
  anotherPersonIdentity,
  anotherAppointmentDt,
  anotherLiveApptTimeslotId,
  bookingTxnId
) {
  return await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/change`, {
    serviceId,
    subServiceId,
    enquiryForId,
    visitorIdentity,
    birthYear,
    preferLang,
    otherEnquiryServiceId,
    contactNo,
    apptTypeId,
    attendingWithAnotherPerson,
    locationId,
    appointmentDt,
    liveApptTimeslotId,
    previousBookingId,
    previousLiveAppTimeslotId,
    anotherPersonIdentity,
    anotherAppointmentDt,
    anotherLiveApptTimeslotId,
    bookingTxnId
  });
}

export async function existedAppointmentBooking(visitorIdentity) {
  return await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/existed`, {
    identity: visitorIdentity
  });
}

export async function verifyOTP(nric, mobile, otp) {
  return await axios.post(`${env.apiUrl}/api/oas/otp/validate`, {
    nric,
    mobile,
    otp
  });
}

export async function appointmentTakenUp(appTypeId, date) {
  return await axios.get(
    `${env.apiUrl}/api/oas/appointment-taken-up?date=${date}&appTypeId=${appTypeId}`
  );
}

export async function getBannerText() {
  return await axios.get(`${env.apiUrl}/api/oas/banner-text`);
}

export async function getAppointmentAvailableDates(apptTypeId, locationId) {
  return await axios.get(
    `${env.apiUrl}/api/oas/appointment-available-dates?apptTypeId=${apptTypeId}${
      locationId ? `&locationId=${locationId}` : ""
    }`
  );
}

export async function getCrpsDob() {
  return await axios.get(`${env.apiUrl}/api/oas/crps-dob`);
}

//region PROJECT X


export async function getAppointmentAvailableDates2(locationId, apptTypeId) {
  let result = null;
  try {
    result = await axios.get(
      `${env.apiUrl}/api/oas/appointment-available-dates?apptTypeId=${apptTypeId}${
        locationId ? `&locationId=${locationId}` : ""
      }`
    );
    if(result.data.status === "error") {
      return { status: "ERROR" };
    }
    return { status: "SUCCESS", data: result.data.data };
  } catch (e) {
    return { status: "ERROR" };
  }
}

/**
 *
 * @returns {Promise<{data, status: string}|{status: string}>}
 */
export async function getTimeSlotsX(date, locationId, appointmentTypeId, otpToken) {
  let result = null;
  try {
    result = await axios.get(
      `${
        env.apiUrl
      }/api/oas/timeslotsx?date=${date}&locationId=${locationId}&appTypeId=${appointmentTypeId}&otpToken=${encodeURIComponent(
        otpToken
      )}`
    );
    if (result.status === 401) {
      return { status: "NO_AUTH" };
    }
    if(result.data.status === "error") {
      return { status: "ERROR" };
    }
  } catch (e) {
    return { status: "ERROR" };
  }
  return { status: "SUCCESS", data: result.data.data };
}

export async function createAppointmentBookingX({ timeslotId, name, email, passport, otpToken, idType }) {
  try {
    const result = await axios.post(`${env.apiUrl}/api/oas/appointment-bookingsx`, {
      timeslotId,
      name,
      email,
      passport,
      otpToken,
      idType
    });

    if (result.status === 401) {
      return { status: "NO_AUTH" };
    }
    // 500 in upstream
    if(result.data.status === "error") {
      return { status: result.data.message };
    }

    return result.data;
  } catch (e) {
    return { status: "ERROR" };
  }
}

export async function changeAppointmentBookingX({ timeslotId, name, email, passport, otpToken }) {
  try {
    const result = await axios.post(`${env.apiUrl}/api/oas/appointment-bookingsx/change`, {
      timeslotId,
      name,
      email,
      passport,
      otpToken
    });

    if (result.status === 401) {
      return { status: "NO_AUTH" };
    }
    // 500 in upstream
    if(result.data.status === "error") {
      return { status: result.data.message };
    }

    return result.data;
  } catch (e) {
    return { status: "ERROR" };
  }
}



/**
 * @returns {Promise<{data, status: string}|{status: string}>}
 */
export async function getExistingAppointmentX({ passport, otpToken }) {
  try {
    const result = await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/existedx`, {
      identity: passport,
      otpToken
    });
    // Auth validation fail
    if(result.status === 401) {
      return {status: "NO_AUTH", data: result.data.message}
    }
    // 500 in upstream
    if(result.data.status === "error") {
      return { status: result.data.message };
    }
    return { status: "SUCCESS", data: result.data };
  } catch (e) {
    return { status: "ERROR" };
  }
}

export async function cancelAppointmentBookingX(
    {  email, visitorIdentity, appointmentId, liveApptTimeslotId, appointmentDt, otpToken }
) {
  try {
  let result = await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/cancellationx`, {
      email, visitorIdentity, appointmentId, liveApptTimeslotId, appointmentDt, otpToken
  });
  // Auth validation fail
    if(result.status === 401) {
      return {status: "NO_AUTH"}
    }
    // 500 in upstream
    if(result.data.status === "error") {
      return { status: "ERROR" };
    }
    if(result.data.status) {
      return {status: "SUCCESS"}
    }

    return {status: "ERROR"};
  }catch(e) {
    return {status: "ERROR"};
  }
}


//endregion

//#region o2
// null (don't have appointment) | { createdUsingSingpass, hasApptEmail, hasApptMobile, hasApptNricFin, hasApptPassport } (have appointment)
export const hasAppointment = async (identity) => {
  console.log("hasAppointment", identity)
  // {status:"error"}
  const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/existed-o2`, {
    identity
  })).data;
  if(status === "ok") {
    return data;
  }
  return null;

  /* if(identity === "S6475152B") {
    return {
      hasApptNricFin: identity,
      hasApptPassport: null,
      hasApptEmail: "a*******a@gmail.com",
      hasApptMobile: null,
    };
  } else if(identity === "K123456") {
    return {
      hasApptNricFin: null,
      hasApptPassport: identity,
      hasApptEmail: null,
      hasApptMobile: "9*****44",
    };

  }
  return null; */
}

export const getMainServices = async () => {
  const { data } = (await axios.get(`${env.apiUrl}/api/oas/main-service-o2`)).data;

  const result = data.map(d=>({...d, text: d.web_disp_text}));

  console.log("#getMainServices", ">", result);
  return result;

  // return await axios.get(`${env.apiUrl}/api/oas/main-service/${mainServiceId}`);
  // return [{id: 1, text: "Main Service 1"}, {id: 2, text: "Main Service 2"}, {id:3, text:"Main Service 3"}];
}

export const getSubServices = async (mid) => {
  const {data} = (await axios.get(`${env.apiUrl}/api/oas/main-service-o2/${mid}`)).data;

  const result = data.map(d=>({...d, text: d.web_disp_text, isCrps: d.is_crps ? true : false, isExperience: d.is_experience ? true : false}));

  console.log("#getSubServices", mid, ">", result);
  return result;

  /* if(mid === 1) {
    return [{id: 1, text: "Sub Service 1.1"}, {id: 2, text: "Sub Service 1.2"}];
  }

  if(mid === 2) {
    return [{id: 3, text: "Sub Service 2.1"}, {id: 4, text: "Sub Service 2.2"}];
  }

  return [{id: 5, text: "Sub Service 3.1"}, {id: 6, text: "Sub Service 3.2"}, {id: 7, text: "Sub Service 3.3"}, {id: 8, text: "Sub Service 3.4"}]; */
}


export const getApptTypes = async({ subServiceId, identity, isCrps }) => {
  const {data} = (await axios.post(
    `${env.apiUrl}/api/oas/service-channels-o2`
    , { subServiceId, identity, isCrps })).data;

  console.log("#getApptTypes",  subServiceId, identity, isCrps, ">", data );

  /* if(true) {
    return [];
  } */

  // ##TEMP

  /* if(isCrps) {
  data[0].isSlotAvailable = false;
  data[1].isSlotAvailable = false;
  } */

  return data;

  /* if(sid === 5) {
   return [
    {id: 1, isSlotAvailable: true, apptType: APPT_TYPE.PHONE, apptTypeCode: "CA", label: "Phone call", note: "Schedule a phone call"},
   ];
  }

  if(sid === 6) {
   return [
    {id: 1, isSlotAvailable: false, apptType: APPT_TYPE.PHONE, apptTypeCode: "CA", label: "Phone call", note: "Schedule a phone call"},
   ];
  }

  if(sid === 7) {
    return [
      {id: 4, isSlotAvailable: true, apptType: APPT_TYPE.VISIT, apptTypeCode: "VC", label: "Service centre", note: "Book a visit to you preferred service centre."},
    ];
  }

  if(sid === 8) {
    return [
      {id: 4, isSlotAvailable: false, apptType: APPT_TYPE.VISIT, apptTypeCode: "VC", label: "Service centre", note: "Book a visit to you preferred service centre."},
    ];
  }

  let isSlotAvailable0 = true;
  let isSlotAvailable1 = true;

  if(sid === 2) {
    isSlotAvailable0 = false;
    isSlotAvailable1 = false;
  } else if(sid === 3) {
    isSlotAvailable0 = false;
  } else if(sid === 4) {
    isSlotAvailable1 = false;
  }

  return [
    {id: 1, isSlotAvailable: isSlotAvailable0, apptType: APPT_TYPE.PHONE, apptTypeCode: "CA", label: "Phone call", note: "Schedule a phone call"},
    {id: 4, isSlotAvailable: isSlotAvailable1, apptType: APPT_TYPE.VISIT, apptTypeCode: "VC", label: "Service centre", note: "Book a visit to you preferred service centre."},
  ]; */
}

export const getLocations = async (apptTypeId) => {
  const {data} = (await axios.get(
    `${env.apiUrl}/api/oas/appointment-locations-o2?apptTypeId=${apptTypeId}`
  )).data;

  console.log("#getLocations", apptTypeId, ">", data);
  // return data.filter(d=>d.isSlotAvailable); // this should not have empty result, as isSlotAvailable is already filtered in appt type level
  return data; // this should not have empty result, as isSlotAvailable is already filtered in appt type level
  /* return [
    {id: 1, text: "Maxwell Service Centre", hasEarliestTimeslot: false},
    {id: 2, text: "Tempines Service Centre", hasEarliestTimeslot: true},
    {id: 3, text: "Bishan Service Centre", hasEarliestTimeslot: false},
    {id: 4, text: "Jurong Service Centre", hasEarliestTimeslot: false},
    {id: 5, text: "Woodlands Service Centre", hasEarliestTimeslot: false},
  ]; */
}

export const getDates = async(apptTypeId, locationId) => {
  const {data} = (await axios.get(
    `${env.apiUrl}/api/oas/appointment-available-dates-o2?apptTypeId=${apptTypeId}${
      locationId ? `&locationId=${locationId}` : ""
    }`
  )).data;

  const ret = data.map((d)=>({id: moment(d.apptDate).format(DATE_ID_FORMAT), text: moment(d.apptDate).format(DATE_FORMAT)}));
  console.log("#getDates", apptTypeId, locationId, ">", ret);
  return ret;
  /* return [
    {id:1, text: "01 Jan 2023, Mon"},
    {id:2, text: "02 Jan 2023, Tue"},
  ] */
}

export const getTimeRanges = async(apptTypeId, locationId) => {
  console.log("#getTimeRanges", apptTypeId, locationId);
  return [
    {id:1, text: "09:00am to 10:00am", startTime: "0900", endTime: "1000"},
    {id:2, text: "10:00am to 11:00am", startTime: "1000", endTime: "1100"},
  ]
}

export const getTimeslots = async({ apptDate, locationId, apptTypeId}) => {
  const {status, data} = (await axios.get(
    `${env.apiUrl}/api/oas/timeslots-o2?date=${apptDate}&locationId=${locationId}&appTypeId=${apptTypeId}`
  )).data;


  if(status === "ok") {
    const ret = data.map((d)=>{
      const text = moment(d.apptDateTime).format(TIME_SLOT_FORMAT);
      // delete d.apptDateTime;
      return {...d, text };
    });
    console.log("#getTimeslots", apptDate, locationId, apptTypeId, ">", ret);
    return ret;
  } else {
    console.log("#getTimeslots", apptDate, locationId, apptTypeId, ">", []);
    return [];
  }

  /* let apptDate = "";
  if(apptDateId === 1) {
    apptDate = "01 Jan 2023";
  } else if(apptDateId === 2) {
    apptDate = "02 Jan 2023";
  }

  if(startTime === "0900") {
    return [
      {id:1, text: "09:00am", apptDateTime : moment(`${apptDate} 0900`, "DD MMM YYYY HHmm").toDate()},
      {id:2, text: "09:15am", apptDateTime : moment(`${apptDate} 0915`, "DD MMM YYYY HHmm").toDate()},
      {id:3, text: "09:30am", apptDateTime : moment(`${apptDate} 0930`, "DD MMM YYYY HHmm").toDate()},
      {id:4, text: "09:45am", apptDateTime : moment(`${apptDate} 0945`, "DD MMM YYYY HHmm").toDate()},
    ]
  } else if(startTime === "1000") {
    return [
      {id:5, text: "10:00am", apptDateTime : moment(`${apptDate} 1000`, "DD MMM YYYY HHmm").toDate()},
      {id:6, text: "10:15am", apptDateTime : moment(`${apptDate} 1015`, "DD MMM YYYY HHmm").toDate()},
    ]
  }  */
}

// the cache will lost when refresh the page.
let ucdCache = {};
/*
 * @return { 
 *  mobile : string | null,
 *  email : string | null,
 * }
 */
export const getUCDInfo = async (nric) => {
  if(ucdCache[nric]) {
    return ucdCache[nric];
  }
  const { status, data } = (await axios.post(
    `${env.apiUrl}/api/oas/ucd-info`, {
      identity: nric
    }
  )).data;

  if(status === "ok") {
    console.log("#getUCDMobileNumber", nric, ">", data);
    ucdCache = {}; // clear old cache
    ucdCache[nric] = data;
    return data;
  }

  // return silently as not found, null
  console.log("#getUCDMobileNumber", nric, ">", {mobile: null, email: null});
  return {mobile: null, email: null};

  /* if(nric === "S1234567D") {
    return "92207844";
  }

  return null; */
}

export async function getOtpSms({identity, mobile, captchaResponseToken}) {
  const {status} = (await axios.post(`${env.apiUrl}/api/oas/otp/get-o2`, {
    identity,
    mobile,
    captchaResponseToken
  })).data;

  console.log("#getOtpSms", {identity, mobile}, ">", status);
  return status;
}

export async function getOtpSmsById({identity, captchaResponseToken }) {
  const {status} = (await axios.post(`${env.apiUrl}/api/oas/otp/get-by-id-o2`, {
    identity,
    captchaResponseToken
  })).data;

  console.log("#getOtpSmsById", {identity }, ">", status);
  return status;
}

export async function getOtpEmail({ identity, email, captchaResponseToken }) {
  const {status} = (await axios.post(`${env.apiUrl}/api/oas/otp/getEmail-o2`, {
    identity,
    email: email.toUpperCase(),
    captchaResponseToken
  })).data;

  console.log("#getOtpEmail", {identity, email}, ">", status);
  return status;
}

export async function getOtpEmailById({ identity, captchaResponseToken }) {
  const {status} = (await axios.post(`${env.apiUrl}/api/oas/otp/getEmail-by-id-o2`, {
    identity,
    captchaResponseToken: captchaResponseToken
  })).data;

  console.log("#getOtpEmail", {identity }, ">", status);
  return status;
}

export async function validateOtpSms({identity, mobile, otp}) {
  const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/otp/validate-o2`, {
    identity,
    mobile,
    otp
  })).data;

  console.log("#validateOtpSms", {identity, mobile, otp}, ">", data);

  if(status !== "ok") {
    // mute the error
    // error is already handled globally by the interceptor
    return { validation: false, otpToken: null, expAt: null };
  }

  return data;
}

// will not refresh otp token. may set otp token expiry to higher value.
// export async function refreshOtpTokenO2({otpToken}) {
//   const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/otp/refreshToken-o2`, {
//     otpToken
//   })).data;

//   console.log("#refreshOtpToken", {status, data});

//   if(status !== "ok") {
//     // mute the error
//     // error is already handled globally by the interceptor
//     return { validation: false, otpToken: null, expAt: null };
//   }

//   return data;
// }


// will not refresh otp token. may set otp token expiry to higher value.
// xproject
// export async function refreshOtpToken({otpToken}) {
//   const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/otp/refreshToken`, {
//     otpToken
//   })).data;

//   console.log("#refreshOtpToken", {status, data});

//   if(status !== "ok") {
//     // mute the error
//     // error is already handled globally by the interceptor
//     return { validation: false, otpToken: null, expAt: null };
//   }

//   return data;
// }

export async function validateOtpSmsById({identity, otp}) {
  const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/otp/validate-by-id-o2`, {
    identity,
    otp
  })).data;

  console.log("#validateOtpSms", {identity, otp}, ">", data);

  if(status !== "ok") {
    // mute the error
    // error is already handled globally by the interceptor
    return { validation: false, otpToken: null };
  }

  return data;
}

export async function validateOtpEmail({ identity, email, otp }) {
  const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/otp/validateEmail-o2`, {
      identity,
      email: email.toUpperCase(),
      otp
  })).data;

  console.log("#validateOtpEmail", {identity, email, otp}, ">", data);

  if(status !== "ok") {
    // mute the error
    // error is already handled globally by the interceptor
    return { validation: false, otpToken: null, expAt: null };
  }

  return data;
}

export async function validateOtpEmailById({ identity, otp }) {
  const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/otp/validateEmail-by-id-o2`, {
      identity,
      otp
  })).data;

  console.log("#validateOtpEmail", {identity, otp}, ">", data);

  if(status !== "ok") {
    // mute the error
    // error is already handled globally by the interceptor
    return { validation: false, otpToken: null };
  }

  return data;
}

const CREATE_BOOKING_ERROR_MSG = {
  HAVE_ANOTHER_CON: "You already have a confirmed booking.",
  INVALID_DATA: "Invalid data. Please refresh the page and try again.",
  TIME_SLOT_IS_FULL: "Appointment time slot has been taken up. Please choose another available time slot.",
  ERROR: "Unexpected error has occurred. Please try again later.",
}

const UPDATE_BOOKING_ERROR_MSG = {
  DOES_NOT_HAVE_CON: "You do not have a confirmed booking.",
  INVALID_DATA: "Invalid data. Please refresh the page and try again.",
  TIME_SLOT_IS_FULL: "Appointment time slot has been taken up. Please choose another available time slot.",
  ERROR: "Unexpected error has occurred. Please try again later.",
}

// @return CREATE_BOOKING_STATUS
export async function createAppointment() {
  const { idType, nricFin, passport, mid, sid, apptTypeId, language, locationId, 
    companionIdType, companionNricFin, companionPassport, apptTimeslotId, companionApptTimeslotId, mobileNumber, 
    email,
    otpToken,
    mobileUseUCD, mobileNumberFromUCD, emailUseUCD, emailFromUCD,
    isCrps
  } =  store.getState().o2Appointment;

  const { nric: singpassNric } =  store.getState().appointment;


    /* idType:Joi.string().required().label("Id Type"), 
    identity:Joi.string().required().label("Identity"),
    mid:Joi.string().required().label("Main service ID"),
    sid:Joi.string().required().label("Sub service ID"),
    apptTypeId: Joi.number().required().label("Appt type ID"),
    language:Joi.string().required().label("Language"),
    locationId: Joi.number().required().label("Location ID"),
    companionIdType: Joi.string().label("Companion Id Type"),
    companionIdentity: Joi.string().label("Companion Identity"),
    timeslotId: Joi.number().required().label("Timeslot"),
    companionTimeslotId: Joi.number().label("Companion Timeslot"),
    mobileNumber:Joi.string().label("Mobile number"),
    email:Joi.string().label("Email"), */

  const payload = { idType, identity: nricFin || passport, mid, sid, apptTypeId, language, locationId, 
    // if crps use main visitor detail as companion detail
    companionIdType: isCrps ? idType : companionIdType, 
    companionIdentity: isCrps ? (nricFin || passport) : (companionNricFin || companionPassport), 
    apptTimeslotId, 
    companionApptTimeslotId, 
    mobileNumber: mobileUseUCD ? mobileNumberFromUCD : mobileNumber, 
    email: emailUseUCD ? emailFromUCD: email, 
    otpToken, singpassNric  };

  // {"status":"ok","data":{"status":"HAVE_ANOTHER_CON"}}
  const response = (await axios.post(`${env.apiUrl}/api/oas/appointment-bookings-o2`, payload)).data; 
  if(response.status !== "ok") {
    return CREATE_BOOKING_STATUS.ERROR;
  }
  const { status } = response.data;

  if(status !== CREATE_BOOKING_STATUS.OK) { 
    store.dispatch(updateError(CREATE_BOOKING_ERROR_MSG[status]));
  } 
  /* else {
    store.dispatch(updateBookingTxnId(bookingTxnId));
  } */

  return status;
}


// @return UPDATE_BOOKING_STATUS
export async function updateAppointment() {
  const { idType, nricFin, passport, mid, sid, apptTypeId, language, locationId, 
    companionIdType, companionNricFin, companionPassport, apptTimeslotId, companionApptTimeslotId, mobileNumber, 
    email,
    otpToken,
    mobileUseUCD, mobileNumberFromUCD, emailUseUCD, emailFromUCD,
    isCrps
  } =  store.getState().o2Appointment;

  const { nric: singpassNric } =  store.getState().appointment;


    /* idType:Joi.string().required().label("Id Type"), 
    identity:Joi.string().required().label("Identity"),
    mid:Joi.string().required().label("Main service ID"),
    sid:Joi.string().required().label("Sub service ID"),
    apptTypeId: Joi.number().required().label("Appt type ID"),
    language:Joi.string().required().label("Language"),
    locationId: Joi.number().required().label("Location ID"),
    companionIdType: Joi.string().label("Companion Id Type"),
    companionIdentity: Joi.string().label("Companion Identity"),
    timeslotId: Joi.number().required().label("Timeslot"),
    companionTimeslotId: Joi.number().label("Companion Timeslot"),
    mobileNumber:Joi.string().label("Mobile number"),
    email:Joi.string().label("Email"), */

  const payload = { idType, identity: nricFin || passport, mid, sid, apptTypeId, language, locationId, 
    // if crps use main visitor detail as companion detail
    companionIdType: isCrps ? idType : companionIdType, 
    companionIdentity: isCrps ? (nricFin || passport) : (companionNricFin || companionPassport), 
    apptTimeslotId, 
    companionApptTimeslotId, 
    mobileNumber: mobileUseUCD ? mobileNumberFromUCD : mobileNumber, 
    email: emailUseUCD ? emailFromUCD: email, 
    otpToken, singpassNric  };

  // {"status":"ok","data":{"status":"HAVE_ANOTHER_CON"}}
  const response = (await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/change-o2`, payload)).data; 
  if(response.status !== "ok") {
    return UPDATE_BOOKING_STATUS.ERROR;
  }
  const { status } = response.data;

  if(status !== UPDATE_BOOKING_STATUS.OK) { 
    store.dispatch(updateError(UPDATE_BOOKING_ERROR_MSG[status]));
  } 
  /* else {
    store.dispatch(updateBookingTxnId(bookingTxnId));
  } */

  return status;
}


// @return null (error) | true (found) | false (not found)
export async function getAppointment(visitorIdentity, otpToken) {
  const {status, data} = (await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/get-o2`, {
    identity: visitorIdentity,
    otpToken
  })).data;

  if(status !== "ok") {
    // error will be handled by axios interceptor.
    return null;
  }

  console.log("#getAppointment", visitorIdentity, ">", data);
  if(data !== null) {
    store.dispatch(updateState(data));
    return true;
  }
  
  return false;
}

// @return true (success) | false (fail)
export async function cancelAppointment(
  identity,
  otpToken
) {
  const { status } = (await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/cancellation-o2`, {
    identity,
    otpToken
  })).data;
  
  return status === "ok";
}

export async function getAliveCount({
    mobile,
    email
}) {
  const { status, data } = (await axios.post(`${env.apiUrl}/api/oas/appointment-bookings/alive-count-o2`, {
    mobile,
    email
  })).data;

  // const { count, exceed } = data;
  
  return data;
}


export async function verifyCaptcha(
  responseToken
) {
  const result = (await axios.post(`${env.apiUrl}/api/oas/captcha/verify`, {
    responseToken
  })).data;
  
  return result;
}


//endregion
